import {
  Actions,
  type SkillsAction,
} from 'src/components/Profile/Skills/actions';
import {
  getSkillsFromCache,
  getSuggestedSkillsFromCache,
} from 'src/components/Profile/Skills/data';
import { EDIT, ADD } from 'src/consts';
import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';
import type { AppConfig } from 'src/modules/appConfig/types';
import type { ApiClient } from 'src/types';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const createSkillsAnalyticsMiddleware = (
  analytics: Analytics,
  { apolloClient }: ApiClient,
  appConfig: AppConfig,
) =>
  instrumentAnalytics(analytics) &&
  (() => (next: (action: SkillsAction) => void) => (action: SkillsAction) => {
    const { updateCard } = analytics;

    switch (action.type) {
      case Actions.UPDATE_SKILLS_START: {
        const {
          payload: { skills, suggestedSkillsAdded },
        } = action;
        const { zone, language: languageCode } = appConfig;

        const { skills: initialSkills } = getSkillsFromCache({ apolloClient });
        const { suggestedSkills } = getSuggestedSkillsFromCache({
          apolloClient,
          zone,
          languageCode,
        });

        const actionName = initialSkills.length > 0 ? EDIT : ADD;
        const hasSuggestedSkills = suggestedSkills.length > 0;

        updateCard({
          actionName,
          currentPageSection: 'skills',
          customProps: {
            skillsStartTotal: initialSkills.length,
            skillsCompleteTotal: skills.length,
            ...(suggestedSkillsAdded !== null && hasSuggestedSkills
              ? { skillsFromSuggestedTotal: suggestedSkillsAdded }
              : {}),
          },
        });
        break;
      }

      default: {
        break;
      }
    }
    return next(action);
  });
